import apiClient from '@/services/axios'
import { sleep } from '@/composables/utils.js'
import { getErrorMessage } from '@/views/apps/referral-program/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

const getDefaultState = () => ({
  show: false,
  title: 'Export',
  filter: null,
  loading: false,
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_SHOW_MODAL(state, { title, filter }) {
      state.show = true
      state.title = title
      state.filter = filter
    },
    SET_CLOSE_MODAL(state) {
      state.show = false
      setTimeout(() => {
        state.title = 'Export'
        state.filter = null
      }, 300)
    },
    TOGGLE_LOADING(state, status = false) {
      state.loading = status
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async startExport({ commit }, { id, filter }) {
      try {
        commit('TOGGLE_LOADING', true)

        const response = await apiClient.post(
          `${referralApiUrl}/referral-programs/${id}/export`,
          filter,
          {
            headers: {
              'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
          },
        )

        if (response?.status >= 200 && response?.status < 300 && response?.data?.data) {
          await sleep()
          return response.data.data
        }

        getErrorMessage(response?.data)
      } catch (error) {
        console.error('Failed to export:', error)
      } finally {
        commit('TOGGLE_LOADING')
      }
    },
  },
  getters: {
    show: (state) => state.show,
    title: (state) => state.title,
    filter: (state) => state.filter,
    loading: (state) => state.loading,
  },
}
